const ROLES = {
  BODY: 'rowgroup',
  CELL: 'cell',
  COLUMN: 'columnheader',
  HEADER: 'rowgroup',
  ROW: 'row',
  TABLE: 'table',
};

export { ROLES };
